<template>
  <card>
        <template v-slot:header>
            Aktuelle stündliche Auslastung 
        </template>

        <chart-half-donut
                class="mb-2"
                :data="data"
                headline="FooBar"
                :colors="colors"></chart-half-donut>
    </card>
</template>

<script>
import ChartHalfDonut from "./Chart/ChartHalfDonut";
import Card from "./UI/Card";
export default {
    name: "SchedulesByHour",

    components: {
        Card,
        ChartHalfDonut
    },

    data: () => ({
            colors: ['#FF968A','#CCE2CB','#FFDAC1']
    }),

    props: ['currentRentingCountByHour', 'free', 'owners'],

    computed: {
        data() {
            return [{label: 'Gebucht', value: this.currentRentingCountByHour}, {label: 'Verfübgar', value: this.free}, {label: 'Fest vergeben', value: this.owners}];
        }
    }

}
</script>

<style>

</style>